import React from "react";
import { SelectGrantDenyDropdown } from "./SecurityPermission.data";
import PermissionChildItem from "./PermissionChildItem";

const PermissionItem = ({ item, level, onParenetUpdate }) => {

    const onValueChange = (valueItem) => {
        let value = parseInt(valueItem)
        item.itemData.securitySettingId = value;
        onParenetUpdate && onParenetUpdate(item, item.id);
    };

    const onChildUpdate = (childItem) => {
        onParenetUpdate && onParenetUpdate(childItem, childItem.id);
    };

    const options = SelectGrantDenyDropdown;

    return (
        <li className={`active-${Number(level + 1)}drop ${item.isActive ? "active" : ""}`}>
            <div className="parent-part">
                <div className="security-key">{item.itemData.securityKeyName}</div>
                <div className="permission-dropdown">
                    <select className="select2 form-select" value={item.itemData?.securitySettingId} onChange={(event) => onValueChange(event.target.value)}>
                        <option value="" >Select an option</option>
                        {options.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            {item.children && item.children.length > 0 && (
                <PermissionChildItem
                    childItems={item.children}
                    level={level + 1}
                    parentItem={item}
                    onParenetUpdate={onChildUpdate}
                />
            )}
        </li>
    );
};
export default PermissionItem;